import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { api as collectApi } from '@fiverr-private/collect';
import { logger } from '../../shared/logger';
import { LOGS_KEY } from '../../utils/constants';

export const useCollections = ({ shouldFetchCollections, appName, collectProps = {}, logAttributes = {} }) => {
    const [collections, setCollections] = useState([]);

    useEffect(() => {
        const fetchCollections = async () => {
            try {
                const { collections: response } = await collectApi.getCollections();

                setCollections(response);
            } catch (err) {
                logger.error(err, {
                    [LOGS_KEY]: 'Error while fetching collections in CSR',
                    componentProps: logAttributes,
                });
            }
        };

        if (shouldFetchCollections && isEmpty(collectProps) && isEmpty(collections)) {
            fetchCollections();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldFetchCollections]);

    if (!isEmpty(collectProps) || !shouldFetchCollections) {
        return { collectProps };
    }

    return {
        collectProps: {
            collections,
            onUpdateCollections: (collections) => {
                setCollections(collections);
            },
            isLoggedIn: true,
            modalCustomName: appName,
        },
    };
};
